import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface HistoryChatsState {
  historyChatsData: any;
  status: boolean;
  error: string | null;
}

const initialState: HistoryChatsState = {
  historyChatsData: {},
  status: false,
  error: null,
};

const fetchHistoryChats = createAsyncThunk<any>(
  'historyChats/fetchHistoryChats',
  async (_, thunkAPI) => {
    try {
      const response = await API.get(API_ENDPOINTS.GET_HISTORY_CHATS);
      return response.data;
    } catch (error: any) {
      return error.response.data;
    }
  }
);

const historyChatsSlice = createSlice({
  name: 'historyChats',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchHistoryChats.pending, (state: any) => {
        state.status = true;
        state.error = null;
      })
      .addCase(fetchHistoryChats.fulfilled, (state: any, action: PayloadAction<any>) => {
        state.status = false;
        state.historyChatsData = action.payload;
      })
      .addCase(fetchHistoryChats.rejected, (state: any, action: PayloadAction<string>) => {
        state.status = false;
        state.error = action.payload || 'Failed to fetch history chats data';
      });
  },
});

export { fetchHistoryChats };
export const { reset: historyChatsReset } = historyChatsSlice.actions;
export const HistoryChatsReducer = historyChatsSlice.reducer;
